import { ACCOUNT_TYPE } from "@ark/shared";

import { useCurrentAccountType } from "./use-current-account-type";

// True when the current member is a guest in the active workspace.
export function useIsGuest(): boolean {
  return useCurrentAccountType() === ACCOUNT_TYPE.GUEST;
}
